import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  ListItemButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  Avatar,
  TextField,
  CircularProgress,
  InputLabel,
  Skeleton,
  Modal,
  useTheme,
  useMediaQuery,
  InputAdornment,
} from "@mui/material";
import { GrFormEdit } from "react-icons/gr";
import React, { useEffect, useState } from "react";
import { IoIosEye, IoIosCloseCircleOutline } from "react-icons/io";
import { IoIosEyeOff } from "react-icons/io";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";
import { MdArrowRightAlt } from "react-icons/md";
import { MdModeEdit } from "react-icons/md";
import { VscLocation } from "react-icons/vsc";
import {
  GET_ALL_PUSRSES,
  GET_MY_APPOINTMENT,
  GET_MY_ORDERS,
  GET_MY_PRODUCTS,
  GET_MY_SERVICE,
  GET_PROFILE,
  GET_UPCOMING_APPOINTMENTS,
  GET_REQUESTS_FOR_APPOINTMENTS,
  GET_HISTORY_FOR_APPOINTMENTS,
} from "../Utils/Queries";
import {
  DECLINE_APPOINTMENT,
  ACCEPT_APPOINTMENT,
  RESCHEDULE_APPOINTMENT,
} from "../Utils/Mutations";
import { useSnackbar } from "notistack";
import { formatDistanceToNow } from "date-fns";
import AppointmentCard from "./Dashboard/AppointmentCard";

import EmptyData from "../Components/Common/EmptyData";
import AddAccount from "./Dashboard/AddAccount";
import GetPaid from "./Dashboard/GetPaid";
import { CloseOutlined } from "@mui/icons-material";
import Loader from "../Components/Common/Loader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { md: 400, xs: 300 },
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const Dashboard = () => {
  const [hide, setHide] = useState(true);

  const [modalOpen, setModalOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState("");

  const [rescheduleModalOpen, setRescheduleModalOpen] = useState(false);
  const [appointmentToReschedule, setAppointmentToReschedule] = useState(null);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");

  const location = useLocation();

  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();
  const handleAlert = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const { loading, data: wallet, error } = useQuery(GET_ALL_PUSRSES);
  const {
    data,
    loading: proLoaing,
    error: proError,
  } = useQuery(GET_MY_PRODUCTS, { variables: { limit: 100 } });
  const {
    data: service,
    loading: serLoading,
    error: serError,
  } = useQuery(GET_MY_SERVICE, { variables: { limit: 100 } });

  const {
    data: orders,
    loading: orderLoading,
    error: orderError,
  } = useQuery(GET_MY_ORDERS);

  const {
    data: appointments,
    loading: apLoading,
    error: apError,
  } = useQuery(GET_MY_APPOINTMENT);

  const {
    data: upcomingAppointments,
    loading: uALoading,
    error: uAError,
  } = useQuery(GET_UPCOMING_APPOINTMENTS);

  const {
    data: requestAppointments,
    loading: rALoading,
    error: rAError,
  } = useQuery(GET_REQUESTS_FOR_APPOINTMENTS);

  const {
    data: historyAppointments,
    loading: hALoading,
    error: hAError,
  } = useQuery(GET_HISTORY_FOR_APPOINTMENTS);

  const getAppointmentsByCategory = () => {
    if (activeCategory === "Requests") {
      return requestAppointments?.fetchSellerAppointmentRequests?.items || [];
    }
    if (activeCategory === "Upcoming") {
      return upcomingAppointments?.fetchSellerUpcomingAppointments?.items || [];
    }
    if (activeCategory === "History") {
      return historyAppointments?.fetchSellerAppointmentHistory?.items || [];
    }
    return [];
  };

  const storeBalance = wallet?.getWallets[0]?.earningBalance;

  const productCount = data?.fetchMerchantProducts?.items?.length || "00";

  const serviceCount = service?.getMyServices?.items?.length || "00";
  const orderCount = orders?.getSellerOrders?.items || [];
  const appointmentCount =
    appointments?.fetchSellerAppointments?.items?.length || "00";

  if (error) {
    handleAlert(`${error.message}`, "error");
  }
  if (proError) {
    handleAlert(`${proError.message}`, "error");
  }
  if (serError) {
    handleAlert(`${serError.message}`, "error");
  }
  if (orderError) {
    handleAlert(`${orderError.message}`, "error");
  }
  if (apError) {
    handleAlert(`${apError.message}`, "error");
  }

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const {
    data: profile,
    error: profileErrror,
    loading: profileLoading,
  } = useQuery(GET_PROFILE);

  const { firstName, lastName, addresses, imageUrl } =
    profile?.getProfile?.profile || [];

  const [readOnly, setReadOnly] = useState(true);

  const [defaultAddress, setDefaultAddress] = useState([]);

  useEffect(() => {
    if (addresses) {
      const defaultAddress = addresses?.filter(
        (item) => item?.isDefault === true
      );
      setDefaultAddress(defaultAddress);
    }
  }, [addresses]);

  const [acceptAppointment, { loading: acceptLoading }] =
    useMutation(ACCEPT_APPOINTMENT);

  const [declineAppointment, { loading: declineLoading }] =
    useMutation(DECLINE_APPOINTMENT);

  const [rescheduleAppointment, { loading: rescheduleLoading }] = useMutation(
    RESCHEDULE_APPOINTMENT
  );

  const handleAccept = async (appointmentId) => {
    try {
      const res = await acceptAppointment({ variables: { appointmentId } });
      handleAlert("Appointment accepted successfully", "success");
    } catch (err) {
      handleAlert(err.message, "error");
    }
  };

  const handleDecline = async (appointmentId) => {
    try {
      const res = await declineAppointment({ variables: { appointmentId } });
      handleAlert("Appointment declined successfully", "success");
    } catch (err) {
      handleAlert(err.message, "error");
    }
  };

  const handleRescheduleOpen = (appointment) => {
    setAppointmentToReschedule(appointment);
    setDate("");
    setTime("");
    setRescheduleModalOpen(true);
  };

  const handleCloseReschedule = () => {
    setRescheduleModalOpen(false);
    setAppointmentToReschedule(null);
  };

  const handleBookOffer = async () => {
    if (!appointmentToReschedule || !date || !time) {
      return handleAlert("Date and time are required.", "error");
    }

    try {
      const { data } = await rescheduleAppointment({
        variables: {
          appointmentId: appointmentToReschedule._id,
          scheduledDate: date,
          scheduledTime: time,
        },
      });
      handleAlert("Appointment rescheduled successfully", "success");
      handleCloseReschedule();
    } catch (err) {
      handleAlert(err.message, "error");
    }
  };


 
  return (
    <>
      <Grid container spacing={4}>
        <Grid item md={8} sm={12} xs={12}>
          {isMobile && (
            <Box
              sx={{
                border: "1px solid #E4E4E7",
                bgcolor: "#fff",
                p: 2,
                borderRadius: "10px",
                mb: 2,
              }}
            >
              <Typography sx={{ color: "#151515", fontWeight: 500 }}>
                Business Profile
              </Typography>
              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  alignItems: "center",
                  columnGap: 2,
                }}
              >
                <Box align="right">
                  <Avatar sx={{ width: "60px", height: "60px" }}>
                    <img src={imageUrl} width={60} />
                  </Avatar>
                  <IconButton
                    sx={{
                      bgcolor: "#7B408C",
                      width: "30px",
                      height: "30px",
                      mt: -5,
                    }}
                  >
                    <GrFormEdit style={{ color: "#fff" }} />
                  </IconButton>
                </Box>
                <Box sx={{ mt: -3 }}>
                  <Typography sx={{ color: "#151515", fontWeight: 500 }}>
                    {`Hello ${firstName || "--"}`}
                  </Typography>
                  <Typography sx={{ fontSize: "12px", lineHeight: "16px" }}>
                    Upload an image that is 132 pixels square or round.
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ mt: 1 }}>
                <Typography>Business Name</Typography>
                <TextField
                  margin="dense"
                  size="small"
                  fullWidth
                  value={` ${firstName || "--"} ${lastName || "--"}`}
                  InputProps={{
                    style: {
                      borderRadius: "5px",
                      fontWeight: 400,
                    },
                    endAdornment: (
                      <InputAdornment>
                        <IconButton
                          onClick={() =>
                            navigate("/account", {
                              state: { redirectTo: location.pathname },
                            })
                          }
                        >
                          <Typography
                            sx={{ color: "#151515", fontWeight: 600 }}
                          >
                            Edit
                          </Typography>
                        </IconButton>
                      </InputAdornment>
                    ),
                    readOnly: readOnly,
                  }}
                />
              </Box>
              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  alignItems: "center",
                  columnGap: 2,
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: 2,
                    width: "80%",
                  }}
                >
                  <VscLocation />
                  <InputLabel>
                    {defaultAddress[0]?.addressOne || "--"}
                  </InputLabel>
                </Box>

                <Typography
                  onClick={() =>
                    navigate("/account/address", {
                      state: { redirectTo: location.pathname },
                    })
                  }
                  sx={{
                    color: "#151515",
                    textDecoration: "underline",
                    fontWeight: 600,
                    mr: 2.5,
                  }}
                >
                  Edit
                </Typography>
              </Box>
              <Box
                sx={{
                  mt: 2,
                  mb: 1,
                  display: "flex",
                  alignItems: "center",
                  columnGap: 2,
                }}
              >
                <Typography sx={{ fontWeight: 600, color: "#151515" }}>
                  Status:
                </Typography>
                <Typography
                  sx={{
                    width: "fit-content",
                    py: 0.5,
                    color: "#FFBD16",
                    bgcolor: "#FFF8E5",
                    fontSize: "10px",
                    px: 2,
                    fontWeight: 500,
                    borderRadius: "6px",
                  }}
                >
                  Verification Pending
                </Typography>
              </Box>
            </Box>
          )}
          <Box
            sx={{
              border: "1px solid #E4E4E7",
              borderRadius: "8px",
              height: "120px",
              p: 3,
              boxSizing: "border-box",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography sx={{ color: "#151515", fontWeight: 600 }}>
                Store Balance
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", columnGap: 3 }}>
                {hide ? (
                  <Typography
                    sx={{
                      textShadow: "0 0 8px rgba(0, 0, 0, 0.8)",
                      color: "transparent",
                      fontSize: "25px",
                      fontWeight: 700,
                    }}
                  >
                    $XX.XX
                  </Typography>
                ) : loading ? (
                  <CircularProgress size={20} sx={{ mt: 1 }} />
                ) : (
                  <Typography
                    sx={{ fontSize: "25px", color: "#151515", fontWeight: 700 }}
                  >
                    ${parseFloat(storeBalance).toLocaleString()}
                  </Typography>
                )}

                <IconButton onClick={() => setHide(!hide)}>
                  {hide ? (
                    <IoIosEye style={{ fontSize: "15px" }} />
                  ) : (
                    <IoIosEyeOff style={{ fontSize: "15px" }} />
                  )}
                </IconButton>
              </Box>
            </Box>
            <GetPaid storeBalance={storeBalance} />
          </Box>
          <AddAccount />
          <Box sx={{ mt: 3 }}>
            <Typography sx={{ fontWeight: 500, color: "#151515" }}>
              Overview
            </Typography>

            <Table
              sx={{ border: "1px solid #e4e4e7", borderRadius: "10px", mt: 1 }}
            >
              <TableBody sx={{ borderRadius: "10px" }}>
                <TableRow>
                  <TableCell sx={{ borderRight: "1px solid #e4e4e7" }}>
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={{ color: "#151515" }}>
                          My Products
                        </Typography>
                        <Link to="/sell-on-mamaket?tab=Product">
                          <IconButton>
                            <MdArrowRightAlt />
                          </IconButton>
                        </Link>
                      </Box>
                      {proLoaing ? (
                        <CircularProgress size={20} sx={{ mt: 1 }} />
                      ) : (
                        <Typography
                          sx={{
                            fontWeight: 700,
                            color: "#151515",
                            fontSize: "20px",
                          }}
                        >
                          {productCount}
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={{ color: "#151515" }}>
                          My Services
                        </Typography>
                        <Link to="/sell-on-mamaket?tab=Service">
                          <IconButton>
                            <MdArrowRightAlt />
                          </IconButton>
                        </Link>
                      </Box>
                      {serLoading ? (
                        <CircularProgress size={20} sx={{ mt: 1 }} />
                      ) : (
                        <Typography
                          sx={{
                            fontWeight: 700,
                            color: "#151515",
                            fontSize: "20px",
                          }}
                        >
                          {serviceCount}
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ borderRight: "1px solid #e4e4e7" }}>
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={{ color: "#151515" }}>
                          My Orders
                        </Typography>
                        <Link to="/sell-on-mamaket?tab=Orders">
                          <IconButton>
                            <MdArrowRightAlt />
                          </IconButton>
                        </Link>
                      </Box>
                      {orderLoading ? (
                        <CircularProgress size={20} sx={{ mt: 1 }} />
                      ) : (
                        <Typography
                          sx={{
                            fontWeight: 700,
                            color: "#151515",
                            fontSize: "20px",
                          }}
                        >
                          {orderCount?.length}
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={{ color: "#151515" }}>
                          My Appointments
                        </Typography>
                        <Link to="/sell-on-mamaket?tab=Orders&type=appointment">
                          <IconButton>
                            <MdArrowRightAlt />
                          </IconButton>
                        </Link>
                      </Box>
                      {apLoading ? (
                        <CircularProgress size={20} sx={{ mt: 1 }} />
                      ) : (
                        <Typography
                          sx={{
                            fontWeight: 700,
                            color: "#151515",
                            fontSize: "20px",
                          }}
                        >
                          {appointmentCount}
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              gap: 10,
            }}
          >
            <Box sx={{ mt: 3, flex: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography sx={{ fontWeight: 500, color: "#151515" }}>
                  Service Appointment
                </Typography>
              </Box>
              <Box
                sx={{
                  border: "1px solid #E4E4E7",
                  borderRadius: "8px",
                  height: "120px",
                  p: 0,
                  boxSizing: "border-box",
                  px: 2,
                  py: 1,
                  mt: 1,
                }}
              >
                <ListItemButton
                  onClick={() => {
                    setActiveCategory("Requests");
                    setModalOpen(true);
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Typography variant="body2">Requests <span style={{background:'#a6202c', borderRadius:'3px', width:'fit-content', color:'#fff', padding:'3px 7px', marginLeft:'14px'}}>{requestAppointments?.fetchSellerAppointmentRequests?.items?.length || 0}</span></Typography>
                    <Typography variant="body2">
                      <svg
                        width="8"
                        height="14"
                        viewBox="0 0 8 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M0.397397 0.39935C0.729342 0.0674042 1.26753 0.0674042 1.59948 0.39935L7.59948 6.39935C7.93142 6.7313 7.93142 7.26949 7.59948 7.60143L1.59948 13.6014C1.26753 13.9334 0.729342 13.9334 0.397397 13.6014C0.0654511 13.2695 0.0654511 12.7313 0.397397 12.3994L5.79636 7.00039L0.397397 1.60143C0.0654511 1.26949 0.0654511 0.731296 0.397397 0.39935Z"
                          fill="#333333"
                        />
                      </svg>
                    </Typography>
                  </Box>
                </ListItemButton>
                <Divider />
                <ListItemButton
                  onClick={() => {
                    setActiveCategory("Upcoming");
                    setModalOpen(true);
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Typography variant="body2">Upcoming <span style={{background:'#f4eff6', color:'#5d3068', borderRadius:'3px', width:'fit-content', padding:'3px 7px', marginLeft:'8px'}}>{upcomingAppointments?.fetchSellerUpcomingAppointments?.items?.length || 0}</span></Typography>
                    <Typography variant="body2">
                      <svg
                        width="8"
                        height="14"
                        viewBox="0 0 8 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M0.397397 0.39935C0.729342 0.0674042 1.26753 0.0674042 1.59948 0.39935L7.59948 6.39935C7.93142 6.7313 7.93142 7.26949 7.59948 7.60143L1.59948 13.6014C1.26753 13.9334 0.729342 13.9334 0.397397 13.6014C0.0654511 13.2695 0.0654511 12.7313 0.397397 12.3994L5.79636 7.00039L0.397397 1.60143C0.0654511 1.26949 0.0654511 0.731296 0.397397 0.39935Z"
                          fill="#333333"
                        />
                      </svg>
                    </Typography>
                  </Box>
                </ListItemButton>
                <Divider />
                <ListItemButton
                  onClick={() => {
                    setActiveCategory("History");
                    setModalOpen(true);
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Typography variant="body2">History </Typography>
                    <Typography variant="body2">
                      <svg
                        width="8"
                        height="14"
                        viewBox="0 0 8 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M0.397397 0.39935C0.729342 0.0674042 1.26753 0.0674042 1.59948 0.39935L7.59948 6.39935C7.93142 6.7313 7.93142 7.26949 7.59948 7.60143L1.59948 13.6014C1.26753 13.9334 0.729342 13.9334 0.397397 13.6014C0.0654511 13.2695 0.0654511 12.7313 0.397397 12.3994L5.79636 7.00039L0.397397 1.60143C0.0654511 1.26949 0.0654511 0.731296 0.397397 0.39935Z"
                          fill="#333333"
                        />
                      </svg>
                    </Typography>
                  </Box>
                </ListItemButton>
              </Box>
            </Box>
            <Box sx={{ mt: 3, flex: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography sx={{ fontWeight: 500, color: "#151515" }}>
                  Products
                </Typography>
              </Box>
              <Box
                sx={{
                  border: "1px solid #E4E4E7",
                  borderRadius: "8px",
                  height: "120px",
                  p: 0,
                  boxSizing: "border-box",
                  px: 2,
                  py: 1,
                  mt: 1,
                }}
              >
                <ListItemButton>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Typography variant="body2">Active listings</Typography>
                    <Typography variant="body2">0</Typography>
                  </Box>
                </ListItemButton>
                <Divider />
                <ListItemButton>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Typography variant="body2">Expired</Typography>
                    <Typography variant="body2">0</Typography>
                  </Box>
                </ListItemButton>
                <Divider />
                <ListItemButton>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Typography variant="body2">Sold out</Typography>
                    <Typography variant="body2">0</Typography>
                  </Box>
                </ListItemButton>
              </Box>
            </Box>
            <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
              <Box
                sx={{
                  bgcolor: "white",
                  p: 3,
                  borderRadius: 2,
                  width: "90%",
                  maxWidth: 600,
                  maxHeight: "90vh",
                  overflowY: "auto",
                  mx: "auto",
                  mt: 5,
                  position: "relative",
                }}
              >
                {/* Modal Header */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 2,
                  }}
                >
                  <Typography fontWeight={600} fontSize="18px">
                    {activeCategory}
                  </Typography>
                  <IconButton onClick={() => setModalOpen(false)}>
                    <IoIosCloseCircleOutline />
                  </IconButton>
                </Box>

                {/* List of Appointments */}
                {getAppointmentsByCategory().map((appt) => (
                  <AppointmentCard
                    key={appt._id}
                    appointmentId={`#${appt.reference}`}
                    productTitle={appt.service.title}
                    productPrice={`$${appt.totalPrice}`}
                    appointmentDate={new Date(
                      appt.scheduledDate
                    ).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })}
                    appointmentTime={appt.scheduledTime}
                    productImage={appt.service.images[0]}
                    user={{
                      name: appt.buyer.firstName + " " + appt.buyer.lastName,
                      location: "N/A",
                      avatar: appt.buyer.imageUrl || "/avatar.jpg", // placeholder
                    }}
                    status={appt.status}
                    onAccept={() => handleAccept(appt._id)}
                    onDecline={() => handleDecline(appt._id)}
                    onReschedule={() => handleRescheduleOpen(appt)}
                  />
                ))}
              </Box>
            </Modal>
            <Modal
              open={rescheduleModalOpen}
              onClose={handleCloseReschedule}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                {rescheduleLoading && <Loader />}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{ fontWeight: 500, color: "#333", fontSize: "16px" }}
                  >
                    Reschedule Appointment
                  </Typography>
                  <IconButton onClick={handleCloseReschedule}>
                    <CloseOutlined sx={{ color: "#333" }} />
                  </IconButton>
                </Box>

                <Box sx={{ py: 2 }}>
                  <Typography
                    sx={{ color: "#333", fontWeight: 400, fontSize: "12px" }}
                  >
                    Schedule date & time
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item lg={6} xs={6}>
                      <TextField
                        fullWidth
                        type="date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        InputProps={{
                          style: {
                            marginTop: "10px",
                            fontSize: "13px",
                            borderRadius: "8px",
                          },
                        }}
                      />
                    </Grid>
                    <Grid item lg={6} xs={6}>
                      <TextField
                        fullWidth
                        type="time"
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                        InputProps={{
                          style: {
                            marginTop: "10px",
                            fontSize: "13px",
                            borderRadius: "8px",
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>

                <Box sx={{ mt: 3 }}>
                  <Button
                    fullWidth
                    onClick={handleBookOffer}
                    variant="contained"
                    sx={{ borderRadius: "100px" }}
                    disabled={rescheduleLoading}
                  >
                    Confirm
                  </Button>
                </Box>
              </Box>
            </Modal>
          </div>
        </Grid>
        <Grid item md={4} sm={12} xs={12}>
          <Box sx={{ boxSizing: "border-box" }}>
            {!isMobile && (
              <Box
                sx={{
                  border: "1px solid #E4E4E7",
                  bgcolor: "#fff",
                  p: 2,
                  borderRadius: "10px",
                }}
              >
                <Typography sx={{ color: "#151515", fontWeight: 500 }}>
                  Business Profile
                </Typography>
                <Box
                  sx={{
                    mt: 2,
                    display: "flex",
                    alignItems: "center",
                    columnGap: 2,
                  }}
                >
                  <Box align="right">
                    <Avatar sx={{ width: "60px", height: "60px" }}>
                      <img src={imageUrl} width={60} />
                    </Avatar>
                    <IconButton
                      sx={{
                        bgcolor: "#7B408C",
                        width: "30px",
                        height: "30px",
                        mt: -5,
                      }}
                    >
                      <GrFormEdit style={{ color: "#fff" }} />
                    </IconButton>
                  </Box>
                  <Box sx={{ mt: -3 }}>
                    <Typography sx={{ color: "#151515", fontWeight: 500 }}>
                      {`Hello ${firstName || "--"}`}
                    </Typography>
                    <Typography sx={{ fontSize: "12px", lineHeight: "16px" }}>
                      Upload an image that is 132 pixels square or round.
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ mt: 1 }}>
                  <Typography>Business Name</Typography>
                  <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    value={`${firstName || "--"} ${lastName || "--"}`}
                    InputProps={{
                      style: {
                        borderRadius: "5px",
                        fontWeight: 400,
                      },
                      endAdornment: (
                        <InputAdornment>
                          <IconButton
                            onClick={() =>
                              navigate("/account", {
                                state: { redirectTo: location.pathname },
                              })
                            }
                          >
                            <Typography
                              sx={{ color: "#151515", fontWeight: 600 }}
                            >
                              Edit
                            </Typography>
                          </IconButton>
                        </InputAdornment>
                      ),
                      readOnly: readOnly,
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    mt: 2,
                    display: "flex",
                    alignItems: "center",
                    columnGap: 2,
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      columnGap: 2,
                      width: "80%",
                    }}
                  >
                    <VscLocation />
                    <InputLabel>
                      {defaultAddress[0]?.addressOne || "--"}{" "}
                    </InputLabel>
                  </Box>

                  <Typography
                    onClick={() =>
                      navigate("/account/address", {
                        state: { redirectTo: location.pathname },
                      })
                    }
                    sx={{
                      color: "#151515",
                      textDecoration: "underline",
                      fontWeight: 600,
                      mr: 2.5,
                    }}
                  >
                    Edit
                  </Typography>
                </Box>
                <Box
                  sx={{
                    mt: 2,
                    mb: 1,
                    display: "flex",
                    alignItems: "center",
                    columnGap: 2,
                  }}
                >
                  <Typography sx={{ fontWeight: 600, color: "#151515" }}>
                    Status:
                  </Typography>
                  <Typography
                    sx={{
                      width: "fit-content",
                      py: 0.5,
                      color: "#FFBD16",
                      bgcolor: "#FFF8E5",
                      fontSize: "10px",
                      px: 2,
                      fontWeight: 500,
                      borderRadius: "6px",
                    }}
                  >
                    Verification Pending
                  </Typography>
                </Box>
              </Box>
            )}

            <Box sx={{ mt: 3 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ fontWeight: 500, color: "#151515" }}>
                  Recent Orders
                </Typography>
                <Link to="/sell-on-mamaket?tab=Orders">
                  <Typography
                    sx={{
                      fontWeight: 400,
                      color: "#151515",
                      fontSize: "12px",
                      cursor: "pointer",
                    }}
                  >
                    See All
                  </Typography>
                </Link>
              </Box>

              <Box
                sx={{
                  mt: 1,
                  bgcolor: "#fff",

                  borderRadius: "8px",
                }}
              >
                {orderLoading ? (
                  <>
                    <Skeleton variant="rectangle" height={40} sx={{ mb: 1 }} />
                    <Skeleton variant="rectangle" height={40} sx={{ mb: 1 }} />
                    <Skeleton variant="rectangle" height={40} sx={{ mb: 1 }} />
                    <Skeleton variant="rectangle" height={40} sx={{ mb: 1 }} />
                  </>
                ) : (
                  <>
                    {(orderCount?.length === 0 || !orderCount) && (
                      <Box
                        sx={{
                          height: "300px",
                          display: "grid",
                          placeContent: "center",
                        }}
                      >
                        <EmptyData title="You have no order yet" />
                      </Box>
                    )}
                    {orderCount?.slice(0, 4)?.map((order, index) => (
                      <>
                        <Link
                          key={index}
                          to={`/sell-on-mamaket?tab=Orders&order_id=${order?._id}`}
                        >
                          <ListItemButton>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                columnGap: 2,
                              }}
                            >
                              <Avatar sx={{ objectFit: "contain" }}>
                                {order?.buyer?.imageUrl ? (
                                  <img
                                    src={order?.buyer.imageUrl}
                                    width={"100%"}
                                  />
                                ) : (
                                  order?.buyer?.firstName?.charAt(0)
                                )}
                              </Avatar>
                              <Box>
                                <InputLabel
                                  sx={{
                                    fontSize: "12px",
                                    color: "#151515",
                                    fontWeight: 500,
                                  }}
                                >
                                  {`${order?.buyer?.firstName}`} purchased your
                                  product
                                </InputLabel>
                                <Typography
                                  sx={{ fontSize: "10px", lineHeight: "14px" }}
                                >
                                  {order?.createdAt &&
                                    formatDistanceToNow(
                                      new Date(order?.createdAt),
                                      {
                                        addSuffix: true,
                                      }
                                    )}
                                </Typography>
                              </Box>
                            </Box>
                          </ListItemButton>
                        </Link>
                        <Divider />
                      </>
                    ))}
                  </>
                )}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Dashboard;
